'use client';
import useFetchSimilarSolds from '@th/frontend-shared/src/hooks/queries/useFetchSimilarSolds';
import React from 'react';
import Loader from '../Loader';
import ListingImageCard from './ListingImageCard';
import isListingBlurred from '../../helpers/isListingBlurred';
import { useUser } from '../../contexts/UserContext';

type Props = {
  listingId: string;
};

export default function SimilarSolds({ listingId }: Props) {
  const { listings, isLoading } = useFetchSimilarSolds(listingId);
  const { isLoggedIn } = useUser();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <h3 className="mb-4">Similar Solds</h3>
      <div className="overflow-x-auto flex flex-row gap-x-4">
        {listings.map(listing => {
          const isBlurred = isListingBlurred(listing, isLoggedIn);
          return (
            <div className="flex-none w-4/5 sm:w-2/5" key={listing.id}>
              <ListingImageCard listing={listing} isBlurred={isBlurred} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
